import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useQuery } from "react-query";
import authApi from "../../../service/IdApi";
import { useAppContext } from "../../../context/appContext";
import PageLoading from "../../../components/PageLoading";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Button } from "primereact/button";

const UnclaimedProfiles = () => {
    const { switchCompany, switchUnclaimedProfile } = useAppContext();
    const navigate = useNavigate();
    const [profiles, setProfiles] = useState(null);
    const [profileCount, setProfileCount] = useState(0);
    const [profilesLoaded, setProfilesLoaded] = useState(false);

    const { isLoading, isError, data } = useQuery("Profiles",
        async () => {
            const result = await authApi.get("admin/unclaimed-providers", "", {
                withCredentials: true,
            });
            setProfiles(result.data.providers);
            setProfileCount(result.data.providers.length);
            setProfilesLoaded(true);
            return data;
        }
    );

    const openNew = () => {
        navigate("/account/admin/new-profile");
    };

    const pageHeader = (
        <PageHeading pageTitle="Admin - Unclaimed Profiles">
            <div className="block">
                <Button label="Create" icon="pi pi-plus" className="mr-2" onClick={openNew} />
            </div>
        </PageHeading>
    );

    if (isLoading) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    if (!profilesLoaded) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    // const switchProvider = (name, id) => {
    //     switchCompany(name, id);
    // }

    const switchProviderToProfile = (name, id, vanityName) => {
        switchUnclaimedProfile(name, id, vanityName);
    }

    const createdOnBodyTemplate = (rowData) => {
        var dt = new Date(rowData.createdAt);
        var d = dt.getDate();
        var m = dt.getMonth() + 1;
        var y = dt.getFullYear();
        var dateString = (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d) + '-' + y;
        return <>{dateString}</>;
    };

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                {profileCount > 0 && (
                    <div className="card pt-3 sm:pt-0">
                        {profiles.map((provider, index) =>
                            <div key={index} className=" px-2 pb-3 border-bottom-1 border-400">
                                <Button type="link" onClick={() => switchProviderToProfile(provider.name, provider._id, provider.vanityName)} className="p-button-text text-lg pl-0 pr-0 text-left" label={provider.name}></Button>
                                {provider.vanityName && (
                                    <div>
                                        <a onClick={() => switchProviderToProfile(provider.name, provider._id, provider.vanityName)} className="cursor-pointer" >{"/company/" + provider.vanityName}</a>
                                    </div>
                                )}
                                <div>
                                    <span className="white-space-nowrap">
                                        {provider.address}
                                        {provider.address2 && <br />}
                                        {provider.address2}
                                    </span>
                                    <span>
                                        {provider.city && <br />}
                                        {provider.city}
                                        {provider.city && <span>, </span>}
                                        {provider.stateCode} {provider.zipCode}
                                    </span>
                                </div>
                                <div className="mt-2">
                                    Created on {createdOnBodyTemplate(provider)}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UnclaimedProfiles;
